import React from "react";
import {
  Create,
  SimpleForm,
  TopToolbar,
  TextInput,
  required,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const Actions = ({ onCancel }) => (
  <TopToolbar>
    <IconButton onClick={onCancel}>
      <CloseIcon />
    </IconButton>
  </TopToolbar>
);

const DistributionChannelCreate = (props) => (
  <Create title=" " {...props} actions={<Actions {...props} />}>
    <SimpleForm redirect={props.basePath} variant="outlined">
      <TextInput source="name" validate={required()} fullWidth />
      <ReferenceInput
        source="riskLevelId"
        reference="risk-levels"
        validate={required()}
        fullWidth
      >
        <SelectInput />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default DistributionChannelCreate;
